export const FETCH_LMS_LEARNER_ACTIVITY_BY_ID_REQUEST = '@lms/userActivity/FETCH_LMS_LEARNER_ACTIVITY_BY_ID_REQUEST';
export const FETCH_LMS_LEARNER_ACTIVITY_BY_ID_SUCCESS = '@lms/userActivity/FETCH_LMS_LEARNER_ACTIVITY_BY_ID_SUCCESS';
export const FETCH_LMS_LEARNER_ACTIVITY_BY_ID_FAILURE = '@lms/userActivity/FETCH_LMS_LEARNER_ACTIVITY_BY_ID_FAILURE';

export const CLEAR_LMS_LEARNER_ACTIVITY_BY_ID = '@lms/userActivity/CLEAR_LMS_LEARNER_ACTIVITY_BY_ID';

export const UPDATE_LMS_LEARNER_ACTIVITY_REQUEST = '@lms/userActivity/UPDATE_LMS_LEARNER_ACTIVITY_REQUEST';
export const UPDATE_LMS_LEARNER_ACTIVITY_SUCCESS = '@lms/userActivity/UPDATE_LMS_LEARNER_ACTIVITY_SUCCESS';
export const UPDATE_LMS_LEARNER_ACTIVITY_FAILURE = '@lms/userActivity/UPDATE_LMS_LEARNER_ACTIVITY_FAILURE';
